// @flow
import React, {useContext, useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import ArchiverClientApi from '../API/archiverClientApi';
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import {clearStoreOnLogout} from "../ACTIONS/clientActions";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import LICache from "../SUPPORT/LICache";
import LIBtoCache from "../SUPPORT/LIBtoCache";

const SignoutPage = () => {

    const [signOutComplete, setSignoutComplete] = useState(false);
    
    useEffect(() => {
        doSignOut();  
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    
    const [,dispatch] = useContext(StoreContext);
    const [cookies,,removeCookie] = useCookies();
    
    async function doSignOut(fromError:boolean=false) {
        
        if(!fromError) {
            ErrorPopup.hide(); // we can hide the error popup
        }
        Popup.hide();
        
        ArchiverClientApi.sendSignOutRequest()
        .then(() => {
            console.log("signed out at server...");
        })
        .catch((error) => { // ignore and signout anyway
            console.error(`ERROR: failed to signout (${error})`);
            
        })
        .finally(async () => {
            await completeSignoutCleanup();
        });
    }

    async function completeSignoutCleanup() {
        
        dispatch(clearStoreOnLogout());
        
        await LICache.clearAll();
        await LIBtoCache.clearAll();
        LIUtils.doCookieSignoutHook(cookies,removeCookie);
        setSignoutComplete(true);
    }

    if (signOutComplete) {
        return (
            <Redirect to="/signin"/>
        );
    }
    else return null;
};

SignoutPage.propTypes = { };

export default SignoutPage;
